import Button from 'antd/lib/button';
import { useTranslation } from 'react-i18next';
import { CHINESE_SYMBOL, ENGLISH_SYMBOL } from 'i18n';
// import { localStorageService } from 'utils/LocalStorageService';
import { sessionStorageService } from 'utils/SessionStorageService';
import GlobalOutlined from 'assets/images/GlobalOutlined.svg';
import GlobalWhite from 'assets/images/g50-globe.svg';
import { StyledDivider } from './styledComponents';
import './LanguageSelector.less';
interface LanguageSelectorProps {
  white: boolean; // 定义 props 类型
}

const LanguageSelector = ({ white }: LanguageSelectorProps) => {
  const { i18n } = useTranslation();

  const changeLanguage = async (lang: string) => {
    let nextLang = '';
    if (lang === 'EN') {
      nextLang = ENGLISH_SYMBOL;
    } else {
      nextLang = CHINESE_SYMBOL;
    }
    await i18n.changeLanguage(nextLang);
    sessionStorageService.set('i18nLanguage', nextLang);
  };

  return (
    <>
      <img src={white ? GlobalWhite : GlobalOutlined} style={{ width: '20px', height: '20px' }} />
      <Button
        type="text"
        className={`change-lang size-f en-weight ${
          i18n.language === 'en' ? (!white ? 'en-selected' : 'en-selected-white') : ''
        }`}
        size="middle"
        style={{
          color: white ? 'white' : '#20252B',
        }}
        onClick={() => changeLanguage('EN')}
      >
        EN
      </Button>
      <StyledDivider type="vertical" style={{ margin: 0, borderColor: white ? 'white' : '#20252B' }} />
      <Button
        type="text"
        size="middle"
        style={{ color: white ? 'white' : '#20252B' }}
        className={`change-lang size-f ${i18n.language === 'zh' ? (!white ? 'zh-selected' : 'zh-selected-white') : ''}`}
        onClick={() => changeLanguage('繁')}
      >
        繁
      </Button>
    </>
  );
};

export default LanguageSelector;
